import { Space } from "antd";
import AppMonitoring from './AppMonitoring';

export default function AppOverview() {

    return (
        <Space direction="vertical" size="large" className="full-width">
            <AppMonitoring />
        </Space>
    )
}